import theme from '../../theme';

const styles = {
  treeView: {
    p: 1,
    mb: 2,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
};

export default styles;
